import { render, staticRenderFns } from "./VulnHistoryTable.vue?vue&type=template&id=7ab8bf3a"
import script from "./VulnHistoryTable.vue?vue&type=script&lang=js"
export * from "./VulnHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports